import React from 'react';
import { Card, CardContent, Stack } from '@mui/material';
import { MarketingTaskAction } from './Marketing';
import { DelinquentTaskAction } from './Collections';

const TasksConfig: React.FC = () => {
  return (
    <Card>
      <CardContent>
        <Stack direction="column" spacing={2} alignItems="flex-start">
          <MarketingTaskAction />
          <DelinquentTaskAction />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default TasksConfig;
